// CreateEventPage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CreateEventPage.css"; // Import the new stylesheet

export default function CreateEventPage() {
  const [orgName, setOrgName] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Added for loading state
  const navigate = useNavigate();

  const handleNext = async () => {
    if (!orgName.trim()) {
      setError("Organizer name cannot be empty.");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const res = await fetch("https://241hbdvql1.execute-api.ap-south-1.amazonaws.com/praud/orgs");
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await res.json();
      const uniqueIds = [...new Set(data.map(item => item.toLowerCase()))];
      const entered = orgName.trim().toLowerCase();

      if (uniqueIds.includes(entered)) {
        setError("Organizer already exists. Please enter a different name.");
      } else {
        // ✅ Redirect to the next page, passing orgName
        navigate(`/dashboard/${orgName.trim()}`);
      }
    } catch (err) {
      console.error("Error fetching OrgIds:", err);
      setError("Could not verify organizer. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-page-container">
      <div className="form-panel">
        <h1 className="form-title">Create New Linked Show</h1>
        <p className="form-subtitle">Enter an organizer name to begin.</p>
        
        <div className="form-content">
          <input
            type="text"
            placeholder="Enter Organizer Name"
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}
            className="form-input"
            disabled={isLoading}
          />
          {error && <p className="error-message">{error}</p>}
          <button 
            className="form-button" 
            onClick={handleNext} 
            disabled={isLoading}
          >
            {isLoading ? "Verifying..." : "Next"}
          </button>
        </div>
      </div>
    </div>
  );
}